import capitalize from '@/filters/capitalize'

export default function deSnake (input: string) {
  if (!input) return
  return capitalize(input.split('_').join(' '))
}
